// Angular DOM
// Angular Hooks
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
// Third Party Services
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";

@Component({
  selector: "app-info-modal",
  templateUrl: "./info-modal.component.html",
  styleUrls: ["./info-modal.component.scss"]
})
export class InfoModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("content") template: TemplateRef<any>;
  @Input() title: string;
  @Input() bodyText: string;
  @Input() redirectLink: string;
  @Input() actionText: string;
  @Output() actionButtonClicked = new EventEmitter();
  @Output() onClicked = new EventEmitter();


  public modalRef: any;

  private options: NgbModalOptions = {
    backdrop: "static",
    windowClass: "info-modal",
    container: "app-info-modal",
    keyboard: false
  };

  constructor(private modalService: NgbModal, public router: Router) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.options);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
  }

  onOkClicked() {
    this.onClicked.emit();
    this.router.navigateByUrl("/RefreshComponent", { skipLocationChange: true })
      .then(() => this.router.navigate(["patients"]));
  }

  onActionClicked() {
    this.actionButtonClicked.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/info-modal/info-modal.component.ts